<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen  text="Please wait..." />
        <div class="report-box">
            
            <table>
                <thead>
                    <tr>
                        <td colspan="12">
                            <span style="margin-left:10px;">{{pulseTxt1}} {{$t("pressure_range")}}: {{pressureRangeTxt}}</span>
                            <span style="margin-left:20px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="prevPage">{{$t("last_wave")}}</button></span>
                            <span style="margin-left:10px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="nextPage">{{$t("next_wave")}}</button></span>
                            <b-dropdown dropright :text="count_text" variant="outline-secondary" style="margin-left:10px;" size="sm">
                                <b-dropdown-item v-for="(item, index) in pageLength" :key="index" @click="chageCountValue(item)">{{ item }}</b-dropdown-item>
                            </b-dropdown>
                            <span><button type="button" class="btn btn-outline-secondary btn-sm" @click="downloadRowCSV" style="margin-left:20px;">EXPO</button></span>
                        </td>
                    </tr>
                </thead>
                <tr>
                    <td colspan="6">
                        <div>
                            <LineChart :chart-data="lineChartData1" />
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="report-box" style="margin-top:20px;">
            <!-- <vue-element-loading :active="isLoading1" text="Please wait..." /> -->
            <div>
                <div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{{$t("txt_13")}}</th>
                                <th>{{$t("txt_14")}}</th>
                                <th>{{$t("txt_15")}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td class="title">Vlaue/Type</td>
                            <td v-for="(item, index) in report_pulse" :key="index">{{item}}</td>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from '@/components/chart/chart.vue'
export default {
    components: {
      LineChart
    },
    data() {
        return{
            account: '',
            report_id: '',

            pressure_range: [],

            chartData: [],

            lineChartData1: {
                labels: [],
                datasets: []
            },

            pulseTxt1: '第一分波',
            pressureRangeTxt: '',
            pageNow: 1,
            pageLength: 0,
            num: 0,
            count_text: '1',

            obj: {
                ecgObj: [],
            },

            reportData: [],
            report_pulse: [],

            isLoading: false
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.getReportPulseType();
    },
    methods: {
        getReportPulseType() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/pulse/type`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.reportData = res.data.data;
                    this.report_pulse = this.reportData[0];
                    this.getReport();
                }
            })
        },
        getReport() {
            const api = `${process.env.VUE_APP_APIPATH}/client/report/v3/data`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const ecg = res.data.data.ecg;
                    const pulse = res.data.data.row.pulse_row.split(" ");
                    const pressure = res.data.data.row.pressure_row.split(" ");
                    
                    this.drawPulse(ecg, pulse, pressure);
                }
                this.isLoading = false;
            })
        },
        downloadRowCSV() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/single/row/csv`;
            const json = {
                report_id: this.report_id,
                row_id: this.num+1
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const url = res.data.data;
                    window.open(url, '_blank')
                    this.isLoading = false;
                }
            })
        },
        drawPulse(ecg, pulse, pressure) {
            let headAry = [];
            let row = [];
            let pre_index1 = ''; 
            let pre_index2 = '';

            //清除空字符串
            pulse.map(function (val, index) {
                // console.log(currentValue, index)
                if (val == '') {
                pulse.splice(index, 1);
                }
            });

            ecg.map((val, index) => {
                if (val._singal_ecg2 == null || val._single_pulse_index == null) {
                    row = [];
                } else {
                    row = val._single_pulse_index.split(" ");
                }

                headAry.push([parseInt(row[0]), (parseInt(row[0]) + parseInt(row[1]))]);
                pre_index1 = Math.floor(headAry[index][0] / 7);
                pre_index2 = Math.floor(headAry[index][1] / 7);
                this.pressure_range.push(pressure[pre_index1] + ' ~ ' + pressure[pre_index2]);
            })
            this.pressureRangeTxt = this.pressure_range[this.num];
            this.getDataPulse(0, headAry, pulse);
            this.pageLength = headAry.length;
            this.obj.ecgAry = this.obj.ecgObj[0];
            this.getShowChart(this.chartData[0].headAry[0], this.chartData[0].data);
        },
        getDataPulse(num, headAry, pulse){
            this.chartData[num] ={
                headAry: headAry, //[[0, 20], [20, 28]]
                data: pulse //[23,321,2564,8789]
            }
        },
        getShowChart(head, data){
            let dataPX = [];
            let dataPY = [];
            this.dataPulse = [];
            for( let i=(head[0]-1), length=(head[1]-1); i<=length; i++ ){
                this.dataPulse.push( [i, data[i]] );
            }
            this.dataPulse.forEach((item) => {
                dataPX.push(item[0]);
                dataPY.push(item[1]);
            })

            let result = {
                labels: dataPX,
                datasets: [
                {
                    label: this.pulseTxt1,
                    backgroundColor: "transparent",
                    data: dataPY,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData1 = result;
        },
        prevPage() {
            if( this.pageNow > 1 ){
                this.pageNow --;
            }
            this.count_text = this.pageNow;
            this.num = this.pageNow;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.obj.ecgAry = this.obj.ecgObj[this.num - 1];
            this.pressureRangeTxt = this.pressure_range[this.num - 1];
            this.report_pulse = this.reportData[this.num - 1];
            this.getShowChart(this.chartData[0].headAry[this.num - 1], this.chartData[0].data);
        },
        nextPage() {
            if(this.pageNow < this.pageLength){
                this.pageNow ++
            }
            this.count_text = this.pageNow;
            this.num = this.pageNow;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.obj.ecgAry = this.obj.ecgObj[this.num - 1];
            this.pressureRangeTxt = this.pressure_range[this.num - 1];
            this.report_pulse = this.reportData[this.num - 1];
            this.getShowChart(this.chartData[0].headAry[this.num - 1], this.chartData[0].data);
        },
        chageCountValue(index) {
            this.count_text = index;
            this.num = index;
            this.pageNow = index ;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.obj.ecgAry = this.obj.ecgObj[this.num - 1];
            this.pressureRangeTxt = this.pressure_range[this.num - 1];
            this.report_pulse = this.reportData[this.num - 1];
            this.getShowChart(this.chartData[0].headAry[this.num - 1], this.chartData[0].data);
        },
    }
}
</script>